const PREFIX = "LANDING_PAGE";

export class GET_CAROUSEL_CONTENT {
  public static readonly type = `[${PREFIX}] GET CAROUSEL CONTENT`;
  constructor(public readonly payload) {}
}

export class SAVE_QUICKLINK {
  public static readonly type = `[${PREFIX}] SAVE QUICKLINK`;
  constructor(public readonly payload) {}
}

export class GET_SUBMENU_REDIRECTURL {
  public static readonly type = `[${PREFIX}] GET SUBMENU REDIRECTURL`;
  constructor(public readonly payload) {}
}

export class GET_ANNOUNCEMENTS {
  public static readonly type = `[${PREFIX}] GET ANNOUNCEMENTS`;
}

export class GET_USER_PERFORMANCE {
  public static readonly type = `[${PREFIX}] GET USER PERFORMANCE`;
  constructor(public readonly payload) {}
}

export class GET_TOTAL_OUTSTANDING {
  public static readonly type = `[${PREFIX}] GET TOTAL OUTSTANDING`;
  constructor(public readonly payload) {}
}

export class GET_OUTSTANDING_CB {
  public static readonly type = `[${PREFIX}] GET OUTSTANDING CB`;
  constructor(public readonly payload) {}
}

export class GET_POLICY_MANAGEMENT {
  public static readonly type = `[${PREFIX}] GET POLICY MANAGEMENT`;
  constructor(public readonly payload) {}
}

export class RESET_DISABLED_LOADING_STATE {
  public static readonly type = `[${PREFIX}] RESET DISABLED LOADING STATE`;
}

export class GET_LOV {
  public static readonly type = `[${PREFIX}] GET LOV`;
}

export class GET_POSTCODE_INFO {
  public static readonly type = `GET POSTCODE INFO`;
  constructor(public readonly payload: string) {}
}

export class GET_POLICY_STATS {
  public static readonly type = `[${PREFIX}] GET POLICY STATS`;
  constructor(public readonly payload: any) {}
}

export class GET_PERFORMANCE_STATS {
  public static readonly type = `[${PREFIX}] GET PERFORMANCE STATS`;
  constructor(public readonly payload: any) {}
}

export class GET_MENU_LIST {
  public static readonly type = `[${PREFIX}] GET MENU`;
  constructor(public readonly payload: any) {}
}

export class SEND_QL_DATA {
  public static readonly type = `[${PREFIX}] SEND QL INDC`;
  constructor(public readonly payload: any) {}
}

export class REDIRECT_PROFILE {
  public static readonly type = `[${PREFIX}] REDIRECT PROFILE`;
  constructor(public readonly payload) {}
}

export class GET_CHILDSUBMENU_REDIRECTURL {
  public static readonly type = `[${PREFIX}] GET CHILDSUBMENU REDIRECTURL`;
  constructor(public readonly payload) {}
}

//From E-Library
export class SET_PRODUCT_BREADCRUM {
  public static readonly type = `[${PREFIX}] SET PRODUCT BREADCRUM`;
  constructor(public readonly payload) {}
}
